import { LovWithoutIdDTO, TruckTypeWithoutIdDTO } from '@api/ringil-api.v2';

export const findTruckType = (code: string, trucks: TruckTypeWithoutIdDTO[]): TruckTypeWithoutIdDTO => {
  return trucks.find(truckType => truckType.code === code);
};

export const returnTruckDimensions = (id: string, trucks: TruckTypeWithoutIdDTO[]) => {
  const truckType = findTruckType(id, trucks);
  return `${truckType.height || '-'} x ${truckType.width || '-'} x ${truckType.length || '-'} cm`;
};

export const returnTruckName = (id: string, trucks: TruckTypeWithoutIdDTO[]) => {
  const truckType = findTruckType(id, trucks);
  return `${truckType.name}`;
};

export const returnTruckLoadCapacity = (id: string, trucks: TruckTypeWithoutIdDTO[]) => {
  const truckType = findTruckType(id, trucks);

  return `${truckType.loadingCapacity || '-'}${truckType.loadingUnit}`;
};

export const resolveSpecialRequirement = (code: string, specialRequirements: LovWithoutIdDTO[]): LovWithoutIdDTO => {
  return specialRequirements.find(sr => sr.code === code);
};

export const mapCodeToCargoItem = (cargoTypes: LovWithoutIdDTO[], code: string): LovWithoutIdDTO => {
  return cargoTypes.find(ct => ct.code === code);
};
